import React, { useMemo } from 'react';

import { useLDClient } from 'launchdarkly-react-client-sdk';

import { GoogleTagManagerSnippet } from '../../../techstyle-shared/react-marketing';

const DEFAULT_EMPTY_FLAGS = {};

export function LaunchDarklyExperimentVariables({ dataLayerName }) {
  const ldClient = useLDClient();
  const allFlags = ldClient?.allFlags() ?? DEFAULT_EMPTY_FLAGS;

  const experimentFlagEvents = useMemo(() => {
    const flags = [];

    Object.keys(allFlags).forEach((flag) => {
      const variationDetail = ldClient.variationDetail(flag);

      if (variationDetail.reason?.inExperiment) {
        flags.push({
          event: 'InLaunchDarklyExperiment',
          eventCategory: 'Launch Darkly AB Test Key',
          eventAction: flag,
          eventLabel: variationDetail.value,
        });
      }
    });

    return flags;
  }, [allFlags, ldClient]);

  return experimentFlagEvents.map((event) => (
    <GoogleTagManagerSnippet.Push
      key={event.eventAction}
      dataLayerName={dataLayerName}
      data={event}
    />
  ));
}
